import React, { Fragment, useEffect, useState } from 'react'
import { makeStyles, createStyles, withStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import {
  
  TextField,
  Paper,
  Grid,
  Button,
  
  
  
  Container,
  Box
} from '@mui/material'

import useAsnBlogs from './useAsnBlog'
import {
  ConvertDateJSToString,
  ConvertDateSqlToJS
} from '../../utils/dateHelper'
import { SnackBar } from '../SnackBar/Snackbar'
import { SnackBarStatus } from '../../interfaces/SnackBar/SnackBarStatus'
import { useUser } from '../../hooks/useUser'
import { Loading } from '../UI'

/*

Copyright 2022-05-11 por Alfonso Moya Ecomsur Holding S.A ©
Detalle: Se módifica tamaño para bitácora de ASN
*/

interface AsnBlogProps {
  asnId: number
  asnNumber: string
}

const useStyles = makeStyles({
  table: {},
  box: {
    height: 100,
    display: 'flex'
  },
  centerBox: {
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  }
})

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.grey[400],
      color: theme.palette.grey[800]
    },
    body: {
      fontSize: 14
    }
  })
)(TableCell)

export const AsnBlog: React.FC<AsnBlogProps> = ({ asnId, asnNumber }) => {
  const {
    userDataState: { userData }
  } = useUser()

  const classes = useStyles()

  const [comment, setComment] = useState<string>('')

  const {
    loading,
    errorGetAsn,
    errorPostAsn,
    asnBlogs,
    getAsnBlogs,
    postAsnBlogs
  } = useAsnBlogs()

  const [snackBarStatus, setSnackBarStatus] = useState<SnackBarStatus>(
    new SnackBarStatus()
  )

  const handleSnackbar = (isOpen: boolean) => {
    setSnackBarStatus({ ...snackBarStatus, isOpen: isOpen })
  }

  const handlePostComment = () => {
    if (userData === undefined) {
      setSnackBarStatus({
        isOpen: true,
        message:
          'No fue posible obtener datos del usuario para agregar el comentario',
        status: 'error'
      })
    } else {
      const postComment = {
        asnId,
        asnNumber,
        comments: comment,
        createdUserId: userData.userId
      }
      postAsnBlogs(postComment)
      setComment('')
    }
  }

  useEffect(() => {
    getAsnBlogs(asnId, asnNumber)
  }, [getAsnBlogs])

  useEffect(() => {
    if (errorPostAsn !== undefined && errorPostAsn !== '') {
      setSnackBarStatus({
        isOpen: true,
        message: errorPostAsn || '',
        status: 'error'
      })
    }
  }, [errorPostAsn])

  const formatComments = (comments: string) => {
    const lines = comments.split('\n')
    const jsx = lines.map((line) => <div>{line}</div>)
    return jsx
  }

  return (
    <Fragment>
      <TableContainer
        component={Paper}
        style={{ maxHeight: '250px', overflow: 'auto' }}
      >
        <Table
          className={classes.table}
          aria-label='asn-blog-table'
          stickyHeader
        >
          {errorGetAsn !== undefined && <caption>{errorGetAsn}</caption>}
          <TableHead>
            <TableRow>
              <StyledTableCell align='center'>Fecha</StyledTableCell>
              <StyledTableCell align='center'>Estado</StyledTableCell>
              <StyledTableCell align='center'>Observaciones</StyledTableCell>
              <StyledTableCell align='center'>Usuario</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <TableRow>
                <TableCell align='center' colSpan={4}>
                  <Loading />
                </TableCell>
              </TableRow>
            )}
            {errorGetAsn === undefined &&
              asnBlogs.map(
                ({
                  asnBlogId,
                  createdDate,
                  asnState,
                  comments,
                  createdUser
                }) => (
                  <TableRow key={asnBlogId}>
                    <TableCell align='center' component='th' scope='row'>
                      {ConvertDateJSToString(ConvertDateSqlToJS(createdDate))}
                    </TableCell>
                    <TableCell align='center'>{asnState}</TableCell>
                    <TableCell align='left'>
                      {formatComments(comments)}
                    </TableCell>
                    <TableCell align='center'>
                      {createdUser.substring(0, createdUser.indexOf('@'))}
                    </TableCell>
                  </TableRow>
                )
              )}
          </TableBody>
        </Table>
      </TableContainer>

      <Container maxWidth='xl'>
        <Paper elevation={2} style={{ padding: '30px', margin: '30px' }}>
          <Grid container>
            <Grid item xs={12} md={8}>
              <TextField
                disabled={loading}
                rows={4}
                minRows={4}
                maxRows={4}
                variant='outlined'
                multiline
                fullWidth
                placeholder='Observaciones'
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
              alignContent='flex-end'
              alignItems='flex-end'
              justifyContent='flex-end'
            >
              <Box
                component='span'
                m={1}
                className={`${classes.centerBox} ${classes.box}`}
              >
                <Button
                  disabled={comment === '' || loading}
                  variant='contained'
                  color='primary'
                  onClick={handlePostComment}
                  fullWidth
                >
                  Ingresar Observación
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>
      <SnackBar
        open={snackBarStatus.isOpen}
        setOpen={handleSnackbar}
        message={snackBarStatus.message}
        status={snackBarStatus.status}
      ></SnackBar>
    </Fragment>
  )
}
